import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function QuemSomos() {
  return (
    <LegalLayout
      testId="quem-somos-page"
      title="Quem Somos"
      intro="A Inove Tech é uma empresa independente especializada em serviços e reparos para celulares e outros dispositivos, em Vitória da Conquista - BA."
    >
      <Section heading="Nossa história">
        <p>
          Desde 2016, cuidamos do celular de quem precisa dele todos os dias.
          Nascemos para tornar o atendimento simples, direto e transparente —
          sem burocracia e sem letras miúdas.
        </p>
        <p>
          Ao longo dos anos, atendemos milhares de clientes que confiaram na
          gente para resolver problemas de tela, bateria, carregamento e falhas
          internas.
        </p>
      </Section>

      <Section heading="Como trabalhamos">
        <p>
          Você conta o que aconteceu, a gente avalia e explica o que pode ser
          feito. Você entende o próximo passo antes de aprovar qualquer serviço.
          Só seguimos em frente com a sua autorização.
        </p>
      </Section>

      <Section heading="Empresa independente">
        <p>
          A Inove Tech é uma empresa independente. Não possui vínculo comercial,
          autorização, credenciamento ou representação oficial da Apple Inc.,
          Samsung Electronics, Motorola Mobility, Xiaomi Corporation ou
          quaisquer outros fabricantes. As marcas mencionadas pertencem aos seus
          respectivos proprietários e são utilizadas exclusivamente para
          identificar os aparelhos atendidos.
        </p>
      </Section>
    </LegalLayout>
  );
}
